import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";
import { FaFilePdf } from "react-icons/fa";
import { Table } from "rsuite";
const { Column, HeaderCell, Cell } = Table;

function LiquidTable({ data, accountDocument, accountType = "lp" }) {
  const [liquidData, setLiquidData] = useState([]);

  useEffect(() => {
    const document = accountDocument || data?.lp_id;
    const isProviderProforma = accountType === "proforma";
    const movements = [
      {
        date: document?.date,
        number: document?.number,
        detail: document?.number,
        amount: Number(document?.amount) || 0,
        pdf_url: document?.pdf_url,
        comprobante: isProviderProforma ? "Proforma" : "LP",
        sign: 1,
      },
      ...(!isProviderProforma && data?.invoice_tomador_comision?._id
        ? [
            {
              date: data?.invoice_tomador_comision?.date,
              number: data?.invoice_tomador_comision?.number || "Pendiente",
              detail:
                data?.invoice_tomador_comision?.number || "Factura comisión",
              amount: Number(data?.invoice_tomador_comision?.amount) || 0,
              pdf_url: data?.invoice_tomador_comision?.pdf_url,
              comprobante: "Factura comisión",
              sign: -1,
            },
          ]
        : []),
      ...(document?.paymentOrder_id || [])?.map((order) => ({
        ...order,
        detail: order.description || order.number || "Orden de pago",
        comprobante: "OP",
        sign: -1,
      })),
    ];

    let runningBalance = 0;
    const formattedLiquidData = movements
      .filter((movement) => movement.date || movement.amount || movement.number)
      .sort((a, b) => {
        const dateA = moment(a.date).valueOf() || 0;
        const dateB = moment(b.date).valueOf() || 0;
        if (dateA !== dateB) return dateA - dateB;
        const createdAtA = moment(a.createdAt).valueOf() || 0;
        const createdAtB = moment(b.createdAt).valueOf() || 0;
        return createdAtA - createdAtB;
      })
      .map((movement) => {
        const signedAmount = (Number(movement.amount) || 0) * movement.sign;
        runningBalance += signedAmount;

        return {
          ...movement,
          amount: signedAmount,
          saldo: runningBalance,
        };
      });

    setLiquidData(formattedLiquidData);
  }, [data, accountDocument, accountType]);

  return (
    <Row className="mt-4">
      <Col md="12">
        <Table
          height={550}
          bordered
          cellBordered
          wordWrap={true}
          data={liquidData}
        >
          <Column width={140} align="center">
            <HeaderCell>Fecha</HeaderCell>
            <Cell dataKey="fecha">
              {(rowData) => (
                <p>
                  {moment
                    .utc(rowData.date || rowData.receipt_date)
                    .format("DD/MM/YYYY")}
                </p>
              )}
            </Cell>
          </Column>
          <Column width={140} align="center">
            <HeaderCell>Comprobante</HeaderCell>
            <Cell dataKey="comprobante">
              {(rowData) => <p>{rowData.comprobante || "Orden pago"}</p>}
            </Cell>
          </Column>
          <Column width={298} align="right">
            <HeaderCell>Detalle</HeaderCell>
            <Cell dataKey="nroComprobante">
              {(rowData) => (
                <p>
                  {rowData.pdf_url && (
                    <a
                      href={rowData.pdf_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Ver PDF"
                    >
                      <FaFilePdf
                        className="mb-2 mr-2"
                        color="primary"
                        size={18}
                      />
                    </a>
                  )}
                  {rowData.detail || rowData.number}
                </p>
              )}
            </Cell>
          </Column>
          <Column width={260} align="right">
            <HeaderCell>Importe</HeaderCell>
            <Cell dataKey="importe">
              {(rowData) => (
                <p>
                  {" "}
                  <CurrencyFormat
                    value={rowData.amount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"$"}
                  />
                </p>
              )}
            </Cell>
          </Column>
          <Column width={260} align="right">
            <HeaderCell align="middle">Saldo</HeaderCell>
            <Cell dataKey="saldo">
              {(rowData) => (
                <p>
                  {" "}
                  <CurrencyFormat
                    value={rowData.saldo}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"$"}
                  />
                </p>
              )}
            </Cell>
          </Column>
        </Table>
      </Col>
    </Row>
  );
}

export default LiquidTable;
